module.exports = __webpack_public_path__ + "h5/img/nodata.17912f27.png";